export default function getResource(label) {
    const resources = { playVideo: 'Play video' };

    return resources[label];
}
